<section>
  <div class="title-section">
    <h3>{{ title() | translate }}</h3>
    <span *ngIf="rankingType === 'MONTHLY'" class="date">{{ today() | date: 'MMMM yyyy' }}</span>
  </div>

  <div class="content-section">
    <span [innerHTML]="description() | translate"></span>
    <a
      class="info"
      href="#"
      (keydown.enter)="openInfoDialog($event)"
      (keydown.space)="openInfoDialog($event)"
      (click)="openInfoDialog($event)"
      >{{ 'user.ranking.viewMoreInformation' | translate }}</a>
  </div>

  <app-gamification-ranking-card
    (openPositionModal)="isRankingDialogOpened.set(true)"
    (openScoreModal)="isScoreDialogOpened.set(true)"
    [currentPosition]="userRankingSlot()?.position ?? '--'"
    [totalPosition]="rankingByScope()?.totalUsers"
    [currentPoints]="userRankingSlot()?.score ?? 0">
    <ng-container *ngIf="rankingType === 'MONTHLY'" slot="background">
      <app-monthly-ranking-image></app-monthly-ranking-image>
    </ng-container>
    <ng-container *ngIf="rankingType === 'GENERAL'" slot="background">
      <app-general-ranking-image></app-general-ranking-image>
    </ng-container>
  </app-gamification-ranking-card>
</section>

<opac-dialog [open]="isRankingDialogOpened()" (opened)="rankingComponent.refreshTabsIndicator()" (closed)="isRankingDialogOpened.set(false)">
  <div class="header" slot="header">
    <div>
      <h3>{{ title() | translate }}</h3>
      <span *ngIf="today()" class="date">{{ today() | date: 'MMMM yyyy' }}</span>
    </div>
    <opac-button (click)="isRankingDialogOpened.set(false)" [ariaLabel]="'general.close' | translate" [opacTooltip]="'general.close' | translate">
      <opac-icon slot="only-icon" icon="close"></opac-icon>
    </opac-button>
  </div>

  <app-ranking #rankingComponent [ranking]="ranking"></app-ranking>
</opac-dialog>

<opac-dialog [open]="isScoreDialogOpened()" (closed)="isScoreDialogOpened.set(false)">
  <div class="header" slot="header">
    <div>
      <h3>{{ 'user.ranking.points.modal.title' | translate }}</h3>
      <span *ngIf="today()" class="date">{{ today() | date: 'MMMM yyyy' }}</span>
    </div>
    <opac-button (click)="isScoreDialogOpened.set(false)" [ariaLabel]="'general.close' | translate" [opacTooltip]="'general.close' | translate">
      <opac-icon slot="only-icon" icon="close"></opac-icon>
    </opac-button>
  </div>

  <app-score [rankingType]="rankingType"></app-score>
</opac-dialog>
